import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }                 from '../shared/shared.module';
import { WorkshopWebFrameComponent }    from './workshop-web.frame.component';
import { WorkshopWebService }           from './workshop-web.service';
import { WorkshopWebSettingsComponent } from './workshop-web.settings.component';
import { WorkshopWebStates }            from './workshop-web.states';

@NgModule({
  declarations: [
    WorkshopWebFrameComponent,
    WorkshopWebSettingsComponent
  ],
  entryComponents: [
    WorkshopWebSettingsComponent
  ],
  exports: [
    WorkshopWebSettingsComponent
  ],
  imports: [
    SharedModule,
    UIRouterUpgradeModule.forChild({ states: WorkshopWebStates })
  ],
  providers: [
    WorkshopWebService
  ]
})
export class WorkshopWebModule {}
